import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Category, NextCategory } from './NextCategory';
import { mergeClasses } from '@/utils/style';
interface Props {
  nextCategories: Category[];
}
export function NextCategories(props) {
  const $ = _c(15);
  const {
    nextCategories
  } = props;
  const {
    t
  } = useTranslation("faq");
  let t0;
  if ($[0] !== t) {
    t0 = t("moreCategories");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h4 className="mb-6 text-center text-2xl font-bold md:mb-16 md:text-5xl">{t0}</h4>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = nextCategories.length === 1 && "grid-rows-1";
  const t3 = nextCategories.length === 2 && "grid-rows-2";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = mergeClasses("mx-auto grid max-w-132 grid-rows-3 rounded-2xl bg-white px-3 py-4", t2, t3);
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== nextCategories) {
    t5 = nextCategories.map(_temp);
    $[7] = nextCategories;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <div className="relative bg-blue-100 px-4 py-4 pt-12 pb-14 md:pb-40">{t1}{t6}</div>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp(category) {
  return <NextCategory key={category.slug.current} {...category} />;
}